import { grey } from "@material-ui/core/colors";
var theme = {
    props: {
        MuiTextField: {
            variant: "filled"
        },
        MuiSelect: {
            variant: "filled"
        },
        MuiFormControl: {
            variant: "filled"
        },
        MuiInputLabel: {
            variant: "filled"
        },
        MuiInput: {
            variant: "filled"
        },
        MuiFormHelperText: {
            variant: "filled"
        }
    },
    typography: {
        useNextVariants: true,
        fontSize: 13
    },
    overrides: {
        MuiTooltip: {
            tooltip: {
                fontSize: "0.8rem"
            }
        }
    },
    palette: {
        contrastThreshold: 3,
        background: {
            default: "#F8FDFC"
        },
        primary: {
            light: "#395768",
            main: "#0c2e3d",
            dark: "#000417"
        },
        secondary: {
            light: "#FEEFD8",
            main: "#F5A623",
            dark: "#EF8B2C"
        },
        // NOTE: The following are used for status boxes, andon buttons etc.
        error: {
            light: "#FAE4E6",
            main: "#D0021B",
            dark: "#A10215"
        },
        warning: {
            light: "#FEEFD8",
            main: "#F5A623",
            dark: "#EF8B2C"
        },
        info: {
            light: "#E9F8E9",
            main: "#59B78C",
            dark: "#428768"
        }
    },
    blackbird: {
        tertiaryPalette: {
            main: "#f00"
        },
        alarms: {
            ONGOING: {
                color: {
                    normal: "rgb(203,142,141)",
                    selected: "blue",
                    hovered: "red"
                }
            },
            STOPPED: {
                color: {
                    normal: "rgb(173, 223, 239)",
                    selected: "rgb(173, 223, 239)",
                    hovered: "rgb(173, 223, 239)"
                }
            },
            NORMAL: {
                color: {
                    normal: "rgb(224, 224, 224)",
                    selected: "rgb(224, 224, 224)",
                    hovered: "rgb(224, 224, 224)"
                }
            },
            SNOOZED: {
                color: {
                    normal: "rgb(173, 223, 239)",
                    selected: "rgb(173, 223, 239)",
                    hovered: "rgb(173, 223, 239)"
                }
            },
            type: {
                AboveX: {
                    color: "#d9534f"
                },
                BelowX: {
                    color: "#d9534f"
                },
                AboveXForTSeconds: {
                    color: "#5bc0de"
                },
                BelowXForTSeconds: {
                    color: "#5bc0de"
                },
                AboveXForTSecondsWithinYTimeNTimes: {
                    color: "#f0ad4e"
                },
                BelowXForTSecondsWithinYTimeNTimes: {
                    color: "#f0ad4e"
                },
                SumOfTAboveXWithinYTime: {
                    color: "purple"
                },
                SumOfTBelowXWithinYTime: {
                    color: "purple"
                }
            }
        },
        stops: {
            NO_ACT: {
                color: {
                    normal: "rgba(173, 223, 239, 1.0)",
                    selected: "rgba(173, 223, 239, 1.0)",
                    hovered: "rgba(173, 223, 239, 1.0)"
                }
            },
            NON_PROD: {
                color: {
                    normal: "rgba(224, 224, 224, 1.0)",
                    selected: "rgba(224, 224, 224, 1.0)",
                    hovered: "rgba(224, 224, 224, 1.0)"
                }
            },
            BATCH_NON_PROD: {
                color: {
                    normal: "rgba(248, 214, 167, 1.0)",
                    selected: "rgba(248, 214, 167, 1.0)",
                    hovered: "rgba(248, 214, 167, 1.0)"
                }
            },
            DOWNTIME: {
                color: {
                    normal: "rgba(217, 152, 150, 1.0)",
                    selected: "rgba(217, 152, 150, 1.0)",
                    hovered: "rgba(217, 152, 150, 1.0)"
                }
            },
            UNREGISTERED: {
                color: {
                    normal: grey[400],
                    selected: "blue",
                    hovered: "red"
                }
            },
            MICRO_STOP: {
                color: {
                    normal: grey[200],
                    selected: "blue",
                    hovered: "red"
                }
            },
            UNREGISTERED_PLOT_BAND: {
                color: {
                    normal: "rgba(217, 152, 150, 1.0)",
                    selected: "rgba(217, 152, 150, 1.0)",
                    hovered: "rgba(217, 152, 150, 1.0)"
                }
            }
        },
        tableRows: {
            color: {
                hovered: "lightgray"
            }
        }
    }
};
export var base = theme;
